import { ApiUrl } from "./constants";

export async function fetchApiData<T>(url: ApiUrl): Promise<T[]> {
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const result = await res.json();
  return result.result;
}
